import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseDataTablePage } from 'app/common/components/pages/base-data-table.page';
import { DataTableAction, DataTableColumn, IDataTableManager, RemoteDataTableManager } from 'app/common/components/table/types';
import { DataTableUtils } from 'app/common/utils/data-table.utils';
import { iconEdit, iconTrash } from 'app/common/utils/icons.utils';
import { iconAdd } from "app/common/utils/icons.utils"
import { ModalService } from 'app/common/services/modal.service';
import { Permission, PermissionSearchCriteria } from 'app/models/roles';
import { EDIT_PERMISSION_PATH } from "./settings.module"
import { RolesAndPermissionsProvider } from 'app/services/RolesAndPermissionsProvider.service';


@Component({
	selector: 'permissions-list',
	templateUrl: './permissions-list.page.html'
})
export class PermissionsList extends BaseDataTablePage<Permission, Filters> {
	public tableColumns: DataTableColumn[] = [];
	public tableActions: DataTableAction[] = [];
	public filters: Filters = new Filters();
	public iconAdd = iconAdd;
	constructor(_translateService: TranslateService, _activatedRoute: ActivatedRoute, private _router: Router, private _entityProvider: RolesAndPermissionsProvider, private _modalService: ModalService) {
		super(_activatedRoute, true);
		this.createColumms();
		this.createActions();
	}

	protected getDataTableManager = (searchCriteria: PermissionSearchCriteria): IDataTableManager<Permission> => {
		return new RemoteDataTableManager(this._entityProvider.searchPermissions, this.setSearchCriteria, searchCriteria)
	}

	private createColumms = (): void => {
		let nameColumn = DataTableUtils.createStringColumn("name", "userMngt.permissions.nameColumnLabel", true);
		this.tableColumns.push(nameColumn);

		let descriptionColumn = DataTableUtils.createStringColumn("description", "userMngt.permissions.descriptionColumnLabel", false);
		this.tableColumns.push(descriptionColumn);

		let deleteColumn = DataTableUtils.createBooleanColumn("available", "userMngt.permissions.deletedColumnLabel", true);
		this.tableColumns.push(deleteColumn);

	}

	private createActions = (): void => {
		let button = new DataTableAction();
		button.funcToInvoke = this.delete;
		button.label = "common.deleteButtonLabel";
		button.icon = iconTrash;
		button.enableFunc = this.canDelete;
		button.enablePermission = "permissions.write";
		this.tableActions.push(button)

		button = new DataTableAction();
		button.funcToInvoke = this.edit;
		button.label = "common.updateButtonLabel";
		button.icon = iconEdit;
		button.enablePermission = "permissions.write";
		this.tableActions.push(button)
	}

	public edit = (row: Permission): void => {
		const queryParams = {};
		queryParams['returnUrl'] = this.getReturnUrl();
		console.log(queryParams['returnUrl']);
		this._router.navigate([EDIT_PERMISSION_PATH, row.id], { queryParams: queryParams });
	}
	public delete = (row: Permission): void => {
		let callback = (data) => {
			if (data) {
				this._entityProvider.deletePermission(row).subscribe((result) => {
					this.dataTableManager.startSearch();
				})
			}
		}
		this._modalService.showConfirm("common.dialogs.alertRemoveItemTitle", "common.dialogs.alertRemoveItemMessage", {
			callback: callback,
			size: "md"
		});
	}
	public canDelete = (row: Permission): boolean => {
		return !row.deleted;
	}

	public addEntity = () => {
		const queryParams = {};
		queryParams['returnUrl'] = this.getReturnUrl();
		console.log(queryParams['returnUrl']);
		this._router.navigate([EDIT_PERMISSION_PATH], { queryParams: queryParams });

	}

	protected setSearchCriteria = (criteria: PermissionSearchCriteria): void => {
		if (criteria.field == "description")
			criteria.field = "localizedDescriptions.description";
		if (criteria.field == "available")
			criteria.field = "deleted";

	}

	public search = (): void => {
		this.dataTableManager.startSearch();
	}
}


class Filters {
	public name: string = "";
}